import * as React from "react";
import { App } from "antd";

export const useCreatedTaskNotfication = () => {
    const { notification } = App.useApp();

    const handleTaskClick = (taskId: string) => {
        const url = `${process.env.PUBLIC_URL}/tasks/${taskId}`;
        window.open(url, "_blank")!.focus();
    };
    return (taskId: string, alphaId: string) =>
        notification.success({
            message: (
                <div>
                    The task {alphaId} has been created.{" "}
                    <span
                        className="view-task"
                        onClick={() => handleTaskClick(taskId)}
                    >
                        View task
                    </span>
                </div>
            ),
            placement: "top",
            className: "sucess-notification",
            icon: <></>,
            style: { width: 480 },
        });
};
